import Axios from "@/plugins/Axios";

export class SolicitacoesService {
  async syncAll({ page, limit, search }) {
    const response = await Axios().get(
      `solicitacoes-delecao?page=${page}&limit=${limit}&search=${search}`
    );
    return response.data;
  }

  async aprovar(id) {
    const response = await Axios().post(`solicitacoes-delecao/aprovar/${id}`);
    return response.data;
  }

  async reprovar(id) {
    const response = await Axios().post(`solicitacoes-delecao/reprovar/${id}`);
    return response.data;
  }
}
export default new SolicitacoesService();
